import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import { ROUTES } from '../../constants';
import PageLoader from './PageLoader';

/**
 * Wraps a route that requires authentication.
 * Waits for Zustand persist hydration before making auth decisions.
 * Optionally restrict to specific roles: <ProtectedRoute roles={['admin']}>
 */
const ProtectedRoute = ({ children, roles = [] }) => {
  const { isAuthenticated, user, _hydrated } = useAuthStore();
  const location = useLocation();

  // Safety fallback — if hydration takes too long, proceed after 300ms
  const [timedOut, setTimedOut] = useState(false);
  useEffect(() => {
    if (_hydrated) return;
    const t = setTimeout(() => setTimedOut(true), 300);
    return () => clearTimeout(t);
  }, [_hydrated]);

  // Wait for localStorage hydration — prevents redirect on hard refresh
  if (!_hydrated && !timedOut) {
    return <PageLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.HOME} replace state={{ from: location }} />;
  }

  if (roles.length && !roles.includes(user?.role)) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return children;
};

export default ProtectedRoute;
